<ng-template #template let-form>
  <ng-container [formGroup]="form">
    <div>
      <h3 class="drawer-title">Ajouter un loyer</h3>
      <div class="form-sct-container">
        <input formControlName="id" type="hidden" />

        <pr-input label="Type de location" [derrors]="derrors">
          <mat-select
            formControlName="rentType"
            (selectionChange)="
              onRentTypeChange(form.parent.controls.indexOf(form))
            "
          >
            @for (option of rentTypeOptions; track option) {
              <mat-option [value]="option.id">{{ option.value }}</mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input label="Régime fiscal" [derrors]="derrors">
          <mat-select formControlName="rentFiscalLaw">
            @for (
              option of getFiscalLawOptions(form.parent.controls.indexOf(form));
              track option
            ) {
              <mat-option [value]="option.id">{{ option.value }}</mat-option>
            }
          </mat-select>
        </pr-input>

   
        <pr-input label="Location partielle" [derrors]="derrors">
          <mat-select
            formControlName="isPartialRent"
            (selectionChange)="
              onPartialRentChange(form.parent.controls.indexOf(form))
            "
          >
            <mat-option [value]="false">Non (location entière)</mat-option>
            <mat-option [value]="true">Oui</mat-option>
          </mat-select>
        </pr-input>

    
        @if (form.get('isPartialRent').value === true) {
          <div class="partial-rent-section">
            <pr-input
              [label]="'Surface louée'"
              [suffix]="'m²'"
              [derrors]="derrors"
            >
              <input formControlName="rentedArea" type="number" min="1" />
            </pr-input>
            <div class="property-area-info">
              <span class="label">Surface totale du bien :</span>
              @if (getPropertyAreaSize()) {
                <span class="value">{{ getPropertyAreaSize() }} m²</span>
              } @else {
                <span class="value error">Non renseignée (obligatoire)</span>
              }
            </div>
          </div>
        }

        <pr-input [label]="'Loyer perçu'" [suffix]="'€'" [derrors]="derrors">
          <input formControlName="amount" type="text" />
        </pr-input>

        <pr-input label="Fréquence" [derrors]="derrors">
          <mat-select formControlName="frequency">
            @for (periodicityType of periodicityTypes; track periodicityType) {
              <mat-option [value]="periodicityType.id">
                {{ periodicityType.value | translate }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input-date
          formControlName="startDate"
          label="Date de début"
          [derrors]="derrors"
        ></pr-input-date>

        <pr-input-date
          formControlName="endDate"
          label="Date de fin"
          [derrors]="derrors"
        ></pr-input-date>
      </div>
    </div>
    <div [formGroup]="form.get('tenant')">
      <h3 class="drawer-title">Informations sur le locataire</h3>
      <div class="form-sct-container">
        <pr-input [label]="'Nom'" [derrors]="derrors">
          <input formControlName="lastName" type="text" />
        </pr-input>

        <pr-input [label]="'Prénom'" [derrors]="derrors">
          <input formControlName="firstName" type="text" />
        </pr-input>

        <pr-input [label]="'Adresse Email'" [derrors]="derrors">
          <input formControlName="email" type="text" />
        </pr-input>

        <pr-input [label]="'Téléphone'" [phoneMask]="true" [derrors]="derrors">
          <input
            formControlName="phone"
            type="text"
            mask="00 00 00 00 00"
            [showMaskTyped]="true"
          />
        </pr-input>
      </div>
    </div>
  </ng-container>
</ng-template>

<div [formGroup]="form">
  <ul formArrayName="rents">
    <pr-form-list-item
      *ngFor="let item of rents.controls; let i = index"
      [formGroup]="item"
      [index]="i"
      headerClass="horizontal-title-list-item"
      buttonIconVbWidth="23"
      buttonIconVbHeight="23"
      buttonStyle="label"
      buttonClass="btn-nostyle neutral btn-list-remove"
      itemName="ce loyer"
      [context]="this"
      [derrors]="derrors"
      (onDelete)="onDelete($event)"
    >
      @if (item.get('amount').value) {
        <div class="pr-form-list-title-primary">Loyer {{ i + 1 }}</div>
        <div class="pr-form-list-title-secondary">
          {{ item.get('rentType').value === 'MEUBLEE' ? 'Meublée' : 'Nue' }}
        </div>
        @if (item.get('isPartialRent').value && item.get('rentedArea').value) {
          <div class="pr-form-list-title-tertiary partial-rent-badge">
            Partielle ({{ item.get('rentedArea').value }} m²)
          </div>
        }
        <div>
          {{ item.get('amount').value | currency: 'EUR' : 'symbol' : '.0-0' }}
        </div>
        @if (
          item.get('startDate').value &&
          item.get('startDate').status === 'VALID'
        ) {
          <div class="pr-form-list-title-tertiary">
            {{ item.get('startDate').value | date: 'shortDate' }}
            @if (item.get('endDate').value) {
              au {{ item.get('endDate').value | date: 'shortDate' }}
            }
          </div>
        }
      } @else {
        <div class="pr-form-list-title-primary">Nouveau loyer</div>
      }
      <ng-container
        item
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ $implicit: item }"
      ></ng-container>
    </pr-form-list-item>
    <div class="pr-form-list-add">
      <pr-button
        clazz="btn-list-add neutral"
        rightIcon="sp-plus"
        label="Ajouter un loyer"
        (onClick)="rentFormService.addModel(entity, form.controls)"
      ></pr-button>
    </div>
  </ul>
</div>
